export default "__VITE_ASSET__386bb5dd__"